// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".x-QuickQouteReview {\n  display: flex;\n  flex-direction: column;\n  font-size: 20px;\n  align-items: center;\n  width: 100%;\n}\n.x-QuickQouteReview > * {\n  margin: 10px;\n}\n.x-QuickQouteReview-premiumBadge {\n  background: #f1fff8;\n  border-radius: 5px;\n  padding: 20px;\n}\n", ""]);
// Exports
exports.locals = {
	"root": "x-QuickQouteReview",
	"premiumBadge": "x-QuickQouteReview-premiumBadge"
};
module.exports = exports;
